'use client';

import React from 'react';
import withError from '@/hoc/withError/withError';
import Link from 'next/link';
import Logo from '@/components/common/logo/Logo';
import ButtonNew from '@/components/common/button-new/ButtonNew';

import logoImgObject from '@/components/common/header/assets/logo--white.svg';
import styles from './no-found.module.scss';

const logoImg = logoImgObject.src;

const NotFound = () => (
  <div className={styles['no-match']}>
    <div className={styles['container-logo']}>
      <Link href="/">
        <Logo width="164" height="26" src={logoImg} />
      </Link>
    </div>
    <div className={styles.error}>
      <div className={styles.character} />
    </div>
    <div className={styles['wrapper-text-error']}>
      <p className={styles['text-error']}>Ooops!</p>
      <p className={styles['text-error-additional']}>Page not found…</p>

      <div className={styles['wrapper-btn-no-match']}>
        <Link href="/">
          <ButtonNew
            color="white"
            size="m"
            text="Go to Main Page"
            variant="fill"
            textColor="green"
          />
        </Link>
      </div>
    </div>
  </div>
);

export default withError(
  NotFound,
);
